import React from 'react';
import { formatDeliveryDate, getCutoffTime } from '../../services/dateUtils';
import SkipDelivery from '../SkipDelivery/SkipDelivery';

const DeliveryDateTabs = ({
    deliveryDates,
    selectedDeliveryDate,
    ordersByDeliveryDate,
    deliveryStatusState,
    onDeliveryDateChange,
    // Skip delivery props
    customerToken,
    isLocked,
    onSkipConfirmed,
    subscriptionSummary,
    customerDetails
}) => {
    if (!deliveryDates) return null;
    // Helper function to format lock date (Date object)
    const formatLockDate = (lockDate) => {
        if (!lockDate) return '';

        return lockDate.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            timeZone: 'America/New_York'
        }) + ', ' + lockDate.toLocaleTimeString('en-US', {
            hour: 'numeric',
            hour12: true,
            timeZone: 'America/New_York'
        });
    };

    return (
        <div style={{
            padding: '20px 20px 20px 20px',
        }}>
            <div style={{
                display: 'flex',
                gap: '20px',
                overflowX: 'auto',
                paddingBottom: '10px',
                justifyContent: 'center',
                minWidth: '100%',
            }}>
                {deliveryDates.map(deliveryDate => {
                    const lockDate = getCutoffTime(deliveryDate);

                    return (
                        <div key={deliveryDate} style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <button
                                onClick={() => onDeliveryDateChange(deliveryDate)}
                                style={{
                                    width: '160px',
                                    height: '110px',
                                    padding: '16px 12px',
                                    border: selectedDeliveryDate === deliveryDate
                                        ? '3px solid #ffb13c'
                                        : '2px solid #e0e0e0',
                                    borderRadius: '16px',
                                    backgroundColor: selectedDeliveryDate === deliveryDate
                                        ? '#ffb13c'
                                        : '#ffffff',
                                    color: selectedDeliveryDate === deliveryDate
                                        ? '#ffffff'
                                        : '#333333',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    fontWeight: selectedDeliveryDate === deliveryDate
                                        ? '600'
                                        : '500',
                                    whiteSpace: 'nowrap',
                                    transition: 'all 0.3s ease',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    boxSizing: 'border-box',
                                    boxShadow: selectedDeliveryDate === deliveryDate
                                        ? '0 6px 16px rgba(255, 217, 0, 0.3)'
                                        : '0 4px 12px rgba(238, 235, 209)',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    margin: '15px 8px'
                                }}
                                onMouseEnter={(e) => {
                                    if (selectedDeliveryDate !== deliveryDate) {
                                        e.target.style.transform = 'scale(1.05)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (selectedDeliveryDate !== deliveryDate) {
                                        e.target.style.transform = 'scale(1)';
                                    }
                                }}
                            >

                                {/* Calendar header with date */}
                                <div style={{
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    textAlign: 'center',
                                    marginBottom: '4px',
                                    lineHeight: '1.2'
                                }}>
                                    {formatDeliveryDate(deliveryDate)}
                                </div>

                                {/* Calendar body with meal count */}
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '4px',
                                    flex: 1,
                                    justifyContent: 'center'
                                }}>
                                    {(() => {
                                        const orderedCount = (ordersByDeliveryDate[deliveryDate] || []).filter(o => o.quantity > 0).length;

                                        if (orderedCount === 0) {
                                            return (
                                                <>
                                                    <span style={{
                                                        fontSize: '14px',
                                                        color: selectedDeliveryDate === deliveryDate ? '#ffffff' : 'rgb(255, 124, 68)',
                                                        fontWeight: '600',
                                                        padding: '6px 12px',
                                                        borderRadius: '10px',
                                                        display: 'inline-block',
                                                        textAlign: 'center',
                                                        lineHeight: '1.2'
                                                    }}>
                                                        No meals {/* Skipped icon in top right corner - only show on selected date if it's skipped */}
                                                        {deliveryStatusState[deliveryDate]?.isSkipped && (
                                                            <span style={{
                                                                fontSize: '12px',
                                                                color: 'rgba(209, 38, 38, 0.9)',
                                                                fontWeight: '600',
                                                                display: 'inline-block',
                                                                textAlign: 'center',

                                                            }}>
                                                                (Skipped)
                                                            </span>

                                                        )}
                                                    </span>

                                                    {lockDate && <span style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        paddingTop: '3px',
                                                        fontSize: '14px',
                                                    }}> ⏰&nbsp;<span style={{
                                                        fontSize: '12px',
                                                        color: selectedDeliveryDate === deliveryDate ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.5)',
                                                        textAlign: 'center',
                                                        lineHeight: '1.1',
                                                        paddingTop: '2px'
                                                    }}> {formatLockDate(lockDate)}</span>
                                                    </span>}
                                                </>
                                            );
                                        }
                                        return (
                                            <>
                                                <span style={{
                                                    fontSize: '14px',
                                                    color: selectedDeliveryDate === deliveryDate ? '#ffffff' : '#4CAF50',
                                                    fontWeight: '600',
                                                    backgroundColor: selectedDeliveryDate === deliveryDate ? 'rgba(255, 255, 255, 0.2)' : 'rgba(76, 175, 80, 0.15)',
                                                    padding: '6px 12px',
                                                    borderRadius: '10px',
                                                    display: 'inline-block',
                                                    textAlign: 'center',
                                                    lineHeight: '1.2'
                                                }}>
                                                    {orderedCount} {orderedCount === 1 ? 'meal' : 'meals'}
                                                </span>
                                                {lockDate && <span style={{
                                                    fontSize: '12px',
                                                    color: selectedDeliveryDate === deliveryDate ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.5)',
                                                    textAlign: 'center',
                                                    lineHeight: '1.1',
                                                    paddingTop: '2px'
                                                }}>
                                                    ⏰ {formatLockDate(lockDate)}
                                                </span>}
                                            </>
                                        );
                                    })()}
                                </div>
                            </button>

                            {/* Skip Delivery Button - only show for selected date if not skipped and not locked */}
                            {selectedDeliveryDate === deliveryDate &&
                                deliveryStatusState[deliveryDate]?.hasSubscription &&
                                !deliveryStatusState[deliveryDate]?.isSkipped &&
                                !isLocked && (
                                    <SkipDelivery
                                        subscriptionSummary={subscriptionSummary}
                                        selectedDeliveryDate={deliveryDate}
                                        customerToken={customerToken}
                                        onSkipConfirmed={onSkipConfirmed}
                                        customerName={customerDetails.customer.name}
                                    />
                                )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default DeliveryDateTabs;